import { STATES } from "@/consts/states";

// Reuses the same state name list the state pickers use elsewhere, instead of
// adding a second US-state map for the run report.
const STATE_NAMES_BY_CODE = new Map(STATES.map(([name, code]) => [code, name]));

/** Full state name for a 2-letter code, or undefined when unrecognized. */
export function findStateName(stateCode: string) {
  return STATE_NAMES_BY_CODE.get(stateCode);
}

/** Falls back to the raw code so an unrecognized or synthetic state code
 * (as in tests) still renders instead of disappearing. */
export function stateDisplayName(stateCode: string) {
  return findStateName(stateCode) ?? stateCode;
}
